import { PresentationMode } from '../../common/enums';
import { AppConfig } from '../../models/config/app-config';

export const mekCVisumConfig: AppConfig = {
  umgebung : 'MEK',
  visumAntragsartEnum: 'KURZFRISTIGER_AUFENTHALT',

  // Diese Property wird durch einen vom Backend abgefragten Wert überschrieben
  // (siehe cfg-mek-kurzfristiger-aufenthalt.component.ts und ap2mode.service.ts).
  // Im Backend wird der Ap2Mode durch die Datei active_visum_langfristiger_aufenthalt.cfg in %KARAF_HOME%\etc bzw.
  // %LOCALAPPDATA%\MEK\etc bestimmt (siehe VisumLangfristigerAufenthaltNonVaadinApplicationContentProvider).
  presentationMode: PresentationMode.DEFAULT,

  defaults: {
    referenz: {
      art: '2'
    },
    // vorbelegung der Zwischenobjeckte, da kostenuebername sonst null ist
    kostenuebernahme : {
      reisekostenUebernahme: {},
      lebensunterhalt: {},
      verpflichtungserklaerungsgeber: { art: '1'}
    },
    angabenZurPerson: {
      beruf : {}
    }
  },

  isDokumenteActive: true,
  isLichtbildActive: true,
  isFingerabdruckActive: true,
  isZusaetzlicheAngabenActive: true,
  isKostenuebernahmeActive: true,
  isReisedatenKurzfristigerAufenthaltActive : true
};
